<template>
  <v-row>
    <v-col cols="12" sm="12" md="3" lg="2">
      <div class="simple-data-control-container"
        :style="{ height: textResponse.length > 3 ? ( isExpanded ?  '100%' : '145px') : '' }" 
      >
        <div class="simple-data-response-number mb-1">
          {{ textResponse.length }}
        </div>
        <div class="simple-data-control-description">
          {{ $t("poll.lblResponses") }}
        </div>
      </div>
    </v-col>
    <v-col cols="12" sm="12" md="9" lg="10">
      <div class="simple-data-control-container-left" 
        :style="{ height: textResponse.length > 3 ? ( isExpanded ?  '100%' : '145px') : '' }"
      >
        <div class="subtitle-1 mb-2">
          <v-chip label small color="appBar">
            <v-icon small left>mdi-circle-slice-8</v-icon>
            {{ $t("poll.lblResponses") }}
            <v-icon right small>mdi-circle-slice-8</v-icon>
          </v-chip>
        </div>

        <div class="responses">
          <div
            class="simple-data-control-description mb-2"
            v-for="(text, index) in latestTextResponses"
            :key="index"
          >
            <span class="title-overflow"
              ><v-chip outlined color="secondary" x-small class="pa-1 ma-0">{{
                index + 1
              }}</v-chip>
              <v-tooltip bottom v-if="text">
                <template v-slot:activator="{ on, attrs }">
                  <i v-bind="attrs" v-on="on">"{{ text }}"</i>
                </template>
                <span class="tooltiptext">{{ text }}</span>
              </v-tooltip>
              <i v-else>"{{ text }}"</i>
            </span>
          </div>
        </div>
        <v-tooltip bottom v-if="textResponse.length > 3">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" v-if="textResponse.length > 3"
              v-model="isExpanded"
              icon
              color="grey"
              small
              depressed
              @click="toggleExpand(isExpanded)"
              >
              <v-icon>
                {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-btn>
          </template>
          <span>{{ isExpanded ? $t("tipSeeMore") : $t("tipSeeLess") }}</span>
        </v-tooltip>  
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TextResponse",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    textResponse: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleExpand(val) {
      this.isExpanded = !val;
    },
  },
  computed: {
    latestTextResponses() {
      return this.isExpanded ? this.textResponse : this.textResponse.slice(0, 3);
    },
  },
};
</script>

<style scoped>
.simple-data-control-container {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
}

.simple-data-control-container-left {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: left;
  align-items: left;
  flex: 1 1 auto;
}
.simple-data-response-number {
  white-space: nowrap;
  color: #324154;
  font-size: 28px;
}

.simple-data-control-description {
  white-space: nowrap;
  color: #595959;
  font-size: 15px;
}

.title-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  max-width: 75vw !important;
  text-align: left;
}

.tooltiptext {
  display: block;
  max-width: 75vw;
  text-align: left;
  align-items: left;
}
</style>